import { render } from "./event-value.vue?vue&type=template&id=0064685b&scoped=true"
import script from "./event-value.vue?vue&type=script&lang=js"
export * from "./event-value.vue?vue&type=script&lang=js"

import "./event-value.vue?vue&type=style&index=0&id=0064685b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0064685b"]])

export default __exports__